import { useState } from 'react';
import webApiClient from './../../Utils/webApiClient';
import { msalInstance } from '../../index';
import config from '../../Config/config';
import useRequestHandler from '../useRequestHandler';

/** Hook is used to fetch list of project contacts */
const useListProjectContacts = () => {

    const [ projectContacts, setProjectContacts ] = useState([]);
    const { errorHandler, successHandler } = useRequestHandler();
    const apiClient = webApiClient();

    /** List project contacts
     * @param {integer} projectId - Project id */
    const listProjectContacts = async (projectId = null) => {
        try {

            // Account is set in the index.js
            const account = msalInstance.getActiveAccount();

            const response = await msalInstance.acquireTokenSilent({
                scopes: config.webApi.scopes,
                account: account
            });

            // Create resource path
            let resource = "projects/" + projectId.toString() + "/contacts";

            const result = await apiClient.list(response.accessToken, resource);

            const data = result.data || {};
            const content = data && data.resultData ? data.resultData : [];

            if (content) setProjectContacts(content);

            return successHandler(result, "useListProjectContacts", "list", { hide: true });

        } catch (error) {

            return errorHandler(error, "useListProjectContacts", "list");

        }
    }

    return { projectContacts, listProjectContacts };

}

export default useListProjectContacts;
